import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OptInGetRes } from '../models/opt-in.model';
import { ApiState } from '../../../utils/api-state';

export const createOptInState = createFeatureSelector<ApiState<OptInGetRes>>('optIn');
export const selectOptIn = createSelector(createOptInState, (state) => state?.response);
export const selectIsPaperlessBannerPreviouslyViewed = createSelector(selectOptIn, (state) =>
  state?.length ? Boolean(state.find((obj) => obj.featureType === 'PAPERLESS_BANNER')?.optedIn) : true
);
export const selectIsPaperlessPagePreviouslyViewed = createSelector(selectOptIn, (state) =>
  state?.length ? Boolean(state.find((obj) => obj.featureType === 'PAPERLESS_INTERSTITIAL')?.optedIn) : true
);

export const selectOptInIsLoading = createSelector(createOptInState, (state) => state?.processing);
export const selectOptInIsLoaded = createSelector(createOptInState, (state) => state?.processed);
export const selectOptInError = createSelector(createOptInState, (state) => state?.error);
